import styled from 'styled-components';

export const MenuButton = styled.button`
    padding: 7px 10px;
    background-color: transparent;
    background-image: none;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    color: white;
    outline: none;
    font-size: 14px;

    &:hover {
        background-color: #2a2d32;
    }

    transition: all 0.15s ease-in;
`;

export const HamburgerContainer = styled.div`
    width: 100vw;
    background-color: #0e0e0e;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    transform: translateY(-100%);

    ${props => {
        if (props.isActive) {
            return `
                transform: translateY(45px);
            `;
        }
    }};

    transition: transform 0.5s ease;
`;

export const HamburgerButton = styled.button`
    width: 100%;
    height: 50px;
    color: #fff;
    font-size: 12px;
    border: none;
    outline: none;
    background: transparent;
    cursor: pointer;

    &:hover {
        background-color: #2a2d32;
        opacity: 0.75;
    }

    transition: all 0.5s ease;
`;

export const DropDownBox = styled.div`
    width: 170px;
    position: absolute;
    ${props => {
        if (props.offsetLeft < 170) {
            return `left: 10px`;
        }

        return `right: 10px`;
    }};
    top: 100%;
    // bottom: -10px;
    background-color: #ffffff;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    border-radius: 3px;
    padding: 6px 2px;
    z-index: 100000000;

    & > div {
        padding: 10px;
        transition: all 300ms;
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    & > div:hover {
        background-color: #dddddd;
    }

    & > section {
        padding: 10px;
        display: flex;
        align-items: center;
    }

    z-index: 10000;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Dropdowns/style.js